import { render } from "./onboarding-index.vue?vue&type=template&id=0d73dbb1&lang=pug"
import script from "./onboarding-index.vue?vue&type=script&lang=js"
export * from "./onboarding-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__